import { globalRef } from '@amazon/vinyl-util'
import type { TrackFields } from '@amzn/bf-playback'
import type { PlayQueueBindingDeps } from '@/playback/playQueueBinding'

export interface TrackTileMenuOptions {
    readonly track: TrackFields
    readonly deps: PlayQueueBindingDeps
    readonly x: number
    readonly y: number
}

export type TrackTileMenuOpener = (options: TrackTileMenuOptions) => void

const openerRef = globalRef<{ open: TrackTileMenuOpener | null }>(() => ({ open: null }))

/** Wired at startup: the track menu lives in `track/`, which already imports `browse/`. */
export function setTrackTileMenuOpener(open: TrackTileMenuOpener): void {
    openerRef.value.open = open
}

export function openTrackTileMenu(options: TrackTileMenuOptions): void {
    openerRef.value.open?.(options)
}
